import React from 'react';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

const CarrierAccountAccessConfirmationModal = (props) => {
  const { t } = useTranslation();

  const { handleCancelButtonClick, handleSubmitButtonClick } = props;
  return (
    <div>
      <p>{t('CONFIRM_REQUEST_ACCESS_INFO')}</p>
      <p className="mt-3">
        <span className="font-bold underline">
          {titleize(t('NOTE', { count: 1 }))}
        </span>
        : {t('CONFIRM_REQUEST_ACCESS_NOTE')}
      </p>
      <div className="mt-10 flex justify-around">
        <button
          onClick={handleCancelButtonClick}
          className="button button-hollow-green w-1/3"
        >
          {t('CANCEL')}
        </button>
        <button
          onClick={handleSubmitButtonClick}
          className="button button-green"
        >
          {t('CONFIRM_REQUEST_ACCESS')}
        </button>
      </div>
    </div>
  );
};

export default CarrierAccountAccessConfirmationModal;
